import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisV,
  faEye,
  faBan,
  faCheck , faAward
} from "@fortawesome/free-solid-svg-icons";

const RowActionMenu = ({ row, onView, onBlacklist, onWhitelist , onUnBlacklistClick , onAddRewardPoi }) => {

  // console.log(row)

  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isBlacklisted = row?.is_active === false;

  return (
    <div className="relative inline-block text-left" ref={menuRef}>
      
      {/* 3 DOT BUTTON */}
      <button
        onClick={() => setOpen(!open)}
        className="p-2 rounded hover:bg-gray-200"
      >
        <FontAwesomeIcon icon={faEllipsisV} />
      </button>

      {/* DROPDOWN */}
      {open && (
        <div className="absolute right-0  w-36 bg-white border rounded-lg shadow-lg z-50">

          {/* VIEW */}
          <div
            onClick={() => {
              onView(row.id);
              setOpen(false);
            }}
            className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer"
          >
            <FontAwesomeIcon icon={faEye} />
            View
          </div>

          {/* BLACKLIST / UNBLOCK TOGGLE */}
          {!isBlacklisted ? (
            <div
              onClick={() => {
                onBlacklist(row);
                setOpen(false);
              }}
              className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer text-red-600"
            >
              <FontAwesomeIcon icon={faBan} />
              Blacklist
            </div>
          ) : (
            <div
              onClick={() => {
                onUnBlacklistClick(row);
                setOpen(false);
              }}
              className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer text-green-600"
            >
              <FontAwesomeIcon icon={faCheck} />
              Unblock
            </div>
          )}

            {/* Poi */}
      {  !isBlacklisted &&  <div
            onClick={() => {
              onAddRewardPoi(row);
              setOpen(false);
            }}
            className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer"
          >
            <FontAwesomeIcon icon={faAward} />
            Poi
          </div>}

        </div>
      )}
    </div>
  );
};

export default RowActionMenu;